import Pagination from '@mui/material/Pagination';
import DefaultTablePaginationActions, {
  TablePaginationActionsProps
} from '@mui/material/TablePaginationActions';

export default function TablePaginationActions(props: TablePaginationActionsProps) {
  const { count, page, rowsPerPage, onPageChange, disabled, className } = props;

  if (count === -1) {
    return <DefaultTablePaginationActions {...props} />;
  }

  return (
    <Pagination
      className={className}
      count={rowsPerPage === -1 ? 1 : Math.max(1, Math.ceil(count / rowsPerPage))}
      page={page + 1}
      onChange={(_, nextPage) => onPageChange(null, nextPage - 1)}
      disabled={disabled}
      color="primary"
      shape="rounded"
      size="small"
      siblingCount={1}
      boundaryCount={1}
    />
  );
}
